import { MouseEvent } from 'react';
import { clsx } from 'clsx';
import { Icon } from '../../icon/Icon';
import { getDataIdGenerator } from '../../shared/utils/dataId';
import styles from './IconFloatingButton.module.scss';

export interface IconFloatingButtonProps {
  dataId: string;
  variant?: 'filled' | 'outline' | 'standard' | 'tonal';
  id?: string;
  size?: 'sm' | 'md';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  icon: string;
  iconClasses?: string;
  disabled?: boolean;
}

export function IconFloatingButton({
  dataId,
  variant = 'standard',
  size = 'sm',
  onClick,
  icon,
  iconClasses,
  className,
  disabled,
  ...props
}: IconFloatingButtonProps) {
  const dataIdGenerator = getDataIdGenerator(dataId, 'icon-button');
  const iconSize = size === 'sm' ? 1 : 2;

  return (
    <button
      type='button'
      data-id={dataIdGenerator('')}
      className={clsx(className, styles.iconButton, styles[size], styles[variant])}
      disabled={!!disabled}
      onClick={e => {
        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    >
      <Icon
        dataId={dataIdGenerator(icon)}
        name={icon}
        size={iconSize}
        className={clsx(iconClasses, styles.iconColor)}
      />
    </button>
  );
}
